import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {Redirect} from "react-router";

class EmailConfirmation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            token: '',
            status: {},
        };

        this.logUserIn = this.logUserIn.bind(this);
    }

    logUserIn() {
        this.props.mark_as_logged_in();
        return (<Redirect push={true} to="/dashboard"/>)
    }

    componentDidMount() {
        const {match: {params}} = this.props;

        this.setState({token: params.token});

        axios.post('/api/user/activate', {user_token: params.token})
            .then(
                data => {
                    if (data.data.success) {
                        this.logUserIn();
                    }
                },
                error => {
                    let response_data = error.response.data;
                    this.setState({status: response_data});
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    render() {

        if (this.props.is_logged_in) {
            window.location.href = "https://inbank.lt/self-service/account/profile";
            return null;
        }

        return (
            <div>

                <header className="text-white bg-primary-dark heading-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="heading-block__header">{this.props.t('registration_confirmation')}</h1>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="section window-layout">
                    <div className="container frame">
                        <div className="row">
                            <div className="col-12 my-4 mx-4">
                                <p>{this.props.t('registration_confirmation_explanation')}</p>

                                {this.state.status && this.state.status.message && <div>{this.state.status.message}</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(EmailConfirmation);

